import { Suspense } from "react";

import { Navigate, Outlet } from "react-router-dom";
import { ROUTES } from "router/const";

type PrivateRouteProps = {
  isAuthenticated: boolean;
};

export const PrivateRoute = ({ isAuthenticated }: PrivateRouteProps) => {
  if (!isAuthenticated) return <Navigate to={ROUTES.LOGIN.PATH} replace />;

  return (
    <Suspense fallback={null}>
      <Outlet />
    </Suspense>
  );
};
